<script setup lang="ts">
import { formatResultValue } from '@desktop/views/Relation/utils'

interface Props {
  result?: number | string | null
}

defineProps<Props>()
</script>

<template>
  <span class="w-5">
    {{ formatResultValue(result === undefined ? null : result) }}
  </span>
</template>
